export const palette = {
  black: "#000000",
  gray1: "#8A8D91",
  gray2: "#E4E6EB",
  blue1: "#385898",
  blue2: "#1877F2",
  blue3: "#E7F3FF",
  green: "#5AD539",
  white1: "#FFFFFF",
  white2: "#FFFFFFB2",
};
